<div class="simple-search-container">
  <label class="form-label" *ngIf="label">{{ label }}</label>
  <div *ngIf="showAsDropdown" class="dropdown-container" [class.open]="showDropdown">
    <div class="dropdown-display" cdkOverlayOrigin #dropdownTrigger="cdkOverlayOrigin" tabindex="0"
      (click)="onInputClick()" [class.disabled]="disabled" [title]="buildDynamicTitle()">
      <span class="dropdown-text">{{ getRenderedDisplayValue() || placeholder }}</span>
      <span class="dropdown-arrow"><i class="fa-regular fa-chevron-down"></i></span>
    </div>

    <ng-template #dropdownPanel>
      <div class="dropdown-content">
        <input #searchInput class="dropdown-search" type="text" [value]="searchTerm" (input)="onInputChange($event)"
          (keydown)="onKeyDown($event)" [placeholder]="searchPlaceholder" autocomplete="off" />

        <div class="dropdown-list">
          <div *ngFor="let option of filteredItems; let i = index" class="dropdown-item"
            [class.selected]="isOptionSelected(option)" [class.highlighted]="highlightedIndex === i"
            [class.disabled]="option['disabled']" (mousedown)="selectOption(option)" (mouseenter)="highlightedIndex = i">
            <span class="item-text">{{ getDisplayText(option) }}</span>
          </div>

          <div *ngIf="isLoading && filteredItems.length === 0" class="dropdown-item loading">
            <span class="fas fa-spinner-third fa-spin"></span>
          </div>

          <div *ngIf="!isLoading && filteredItems.length === 0 && showNoResultsMessage" class="dropdown-item no-results">
            {{ GENERIC_SEARCH_CONSTANTS.LOADING_MESSAGES.NO_CLAIMS_AVAILABLE }}
          </div>
        </div>
      </div>
    </ng-template>

    <ng-container *ngIf="showDropdown && !attachToBody" [ngTemplateOutlet]="dropdownPanel"></ng-container>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="dropdownTrigger"
      [cdkConnectedOverlayOpen]="attachToBody && showDropdown" [cdkConnectedOverlayPositions]="overlayPositions"
      [cdkConnectedOverlayWidth]="overlayWidth">
      <ng-container [ngTemplateOutlet]="dropdownPanel"></ng-container>
    </ng-template>
  </div>

  <div *ngIf="!showAsDropdown" class="e-input-wrap">
    <input #searchInput class="form-input" type="text" [value]="getRenderedDisplayValue()" (input)="onInputChange($event)"
      (click)="onInputClick()" (focus)="onInputFocus()" (blur)="onInputBlur($event)" (keydown)="onKeyDown($event)"
      [placeholder]="placeholder" [disabled]="disabled" [title]="buildDynamicTitle()" maxlength="500" autocomplete="off" />

    <div *ngIf="showDropdown" class="search-dropdown">
      <div *ngIf="isLoading && filteredItems.length === 0" class="search-item loading">
        <span class="fas fa-spinner-third fa-spin"></span>
      </div>

      <div *ngFor="let option of filteredItems; let i = index" class="search-item"
        [class.selected]="isOptionSelected(option)" [class.highlighted]="highlightedIndex === i"
        [class.disabled]="option['disabled']" (mousedown)="selectOption(option)" (mouseenter)="highlightedIndex = i">
        <span class="item-text">{{ getDisplayText(option) }}</span>
      </div>

      <div *ngIf="!isLoading && filteredItems.length === 0 && showNoResultsMessage" class="search-item no-results">
        {{ GENERIC_SEARCH_CONSTANTS.LOADING_MESSAGES.NO_CLAIMS_AVAILABLE }}
      </div>
    </div>
  </div>

  <div class="form-error" *ngIf="showErrors">
    <span *ngIf="required && !selectedValue">{{ label || 'This field' }} is required</span>
  </div>
</div>